export const awsURL =
  process.env.AWS_URL ||
  process.env.NEXT_PUBLIC_AWS_URL ||
  'https://britapp-app-development.s3.amazonaws.com'
export const imgixURL =
  process.env.IMGIX_URL ||
  process.env.NEXT_PUBLIC_IMGIX_URL ||
  'https://britapp-dev.imgix.net/images/'
